import styles from "./Badge.module.css";

const COLOR_MAP = {
  // payment status
  Paid:      "green",
  Partial:   "orange",
  Unpaid:    "red",
  // client status
  Active:    "blue",
  Completed: "green",
  "On Hold": "orange",
  Cancelled: "red",
  // employee status
  active:    "green",
  inactive:  "red",
  // job
  true:      "green",
  false:     "red",
};

export default function Badge({ label }) {
  const color = COLOR_MAP[label] ?? "gray";
  return <span className={`${styles.badge} ${styles[color]}`}>{label}</span>;
}
